
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16 8A8 8 0 110 8a8 8 0 0116 0zM7.137 9.555a.234.234 0 00.156.056h1.559c.081 0 .144-.022.189-.067.044-.045.096-.12.156-.226.03-.135.055-.236.078-.304.059-.165.144-.323.256-.473.118-.15.278-.334.478-.552.327-.36.572-.68.735-.958.17-.278.256-.601.256-.969 0-.323-.093-.639-.278-.947-.178-.315-.479-.578-.902-.788C9.397 4.109 8.848 4 8.173 4c-.66 0-1.229.116-1.704.35-.475.232-.834.536-1.08.912A2.229 2.229 0 005 6.434c0 .09.022.165.067.225a.27.27 0 00.2.079h1.358c.17 0 .286-.09.345-.27.134-.564.49-.845 1.069-.845a.94.94 0 01.623.214.58.58 0 01.234.552.854.854 0 01-.19.473c-.118.15-.296.346-.533.586a7.83 7.83 0 00-.757.845c-.179.248-.294.53-.346.845v.26c0 .06.023.112.067.157zm-.022 2.366a.27.27 0 00.2.079H8.74a.27.27 0 00.2-.079c.06-.053.09-.12.09-.203v-1.284c0-.083-.03-.15-.09-.203a.27.27 0 00-.2-.079H7.315a.27.27 0 00-.2.079.276.276 0 00-.078.203v1.284c0 .083.026.15.078.203z","fill":"#999"}})])
          )
        }
      }
    